import { render, staticRenderFns } from "./PayInfo.vue?vue&type=template&id=8ca254a4&scoped=true&"
import script from "./PayInfo.vue?vue&type=script&lang=js&"
export * from "./PayInfo.vue?vue&type=script&lang=js&"
import style0 from "./PayInfo.vue?vue&type=style&index=0&id=8ca254a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca254a4",
  null
  
)

export default component.exports